// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalUserInfo_main__QQ6Kg {
    width: 100%;
    height: 560px;
    padding: 30px 0;
}

.ModalUserInfo_header__86-qa {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 38px;
    font-weight: bold;
    color: #262626;
}

.ModalUserInfo_section__016Tp {
    display: flex;
    width: 100%;
    height: 230px;
    padding-top: 15px;
    border-bottom: 1px solid #CBD1D8;
}

.ModalUserInfo_section_left__Bo8aM {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% - 435px);
    height: 100%;
    padding-right: 24px;
}

.ModalUserInfo_avatar_box__Iw3zL {
    position: relative;
    width: 135px;
    height: 135px;
}

.ModalUserInfo_change_avatar__xXWyD {
    position: absolute;
    width: 32px;
    height: 32px;
    bottom: 0;
    right: 0;
    cursor: pointer;
}

.ModalUserInfo_avatar__gr2jU {
    width: 135px;
    height: 135px;
    border-radius: 50%;
}

.ModalUserInfo_username__LmqdL,
.ModalUserInfo_email__-mIqB {
    font-size: 16px;
    color: #000;
}

.ModalUserInfo_section_right__3UphB {
    width: 435px;
    height: 100%;
}

.ModalUserInfo_form_item__wcWqQ,
.ModalUserInfo_form_item_name__POkjS {
    width: 100%;
    height: 70px;
    margin-bottom: 10px;
}

.ModalUserInfo_form_item__wcWqQ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
}

.ModalUserInfo_form_item_name__POkjS {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ModalUserInfo_firstname_box__WBAwb,
.ModalUserInfo_lastname_box__E203J {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 208px;
    height: 70px;
}

.ModalUserInfo_item_title__ZGryv {
    font-size: 14px;
    font-weight: bold;
    color: #000;
}

.ModalUserInfo_func_butn__cDxRa {
    width: 80px !important;
}

.ModalUserInfo_radio_box__sBuGd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 170px;
    height: 100%;
    padding: 2px;
    border-radius: 6px;
    background-color: #81969d;
}

.ModalUserInfo_radio_item__fska- {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 100%;
    font-size: 14px;
    color: #cbd1d8;
    /* cursor: pointer; */
    cursor: not-allowed;
}

.ModalUserInfo_radio_item_active__VKHfm {
    border-radius: 4px;
    font-weight: bold;
    color: #17a8b5;
    background-color: #fff;
}

.ModalUserInfo_item_size__xpQEx {
    padding: 0 50px;
    flex: 1 1;
    text-align: right;
}

.ModalUserInfo_firstname_input__aUxLN,
.ModalUserInfo_lastname_input__zOUF6,
.ModalUserInfo_nickname_input__85J4M {
    width: 100%;
    height: 43px;
}

.ModalUserInfo_firstname_input__aUxLN:hover,
.ModalUserInfo_firstname_input__aUxLN:focus-within,
.ModalUserInfo_firstname_input__aUxLN:focus,
.ModalUserInfo_lastname_input__zOUF6:hover,
.ModalUserInfo_lastname_input__zOUF6:focus-within,
.ModalUserInfo_lastname_input__zOUF6:focus,
.ModalUserInfo_nickname_input__85J4M:hover,
.ModalUserInfo_nickname_input__85J4M:focus-within,
.ModalUserInfo_nickname_input__85J4M:focus {
    border-color: #17a8b5;
}

.ModalUserInfo_language_select__TKSQF {
    width: 100%;
    height: 43px;
    border-radius: 6px;

}

.ModalUserInfo_section2__SY-nR {
    display: flex;
    width: 100%;
    height: 130px;
    margin: 30px 0;
}

.ModalUserInfo_section2_right__cpa0e {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.ModalUserInfo_func_item__Ihn5D {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 32px;
}

.ModalUserInfo_footer__wGRkT {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: 50px;
}

.ModalUserInfo_delete_account__QA4ak {
    padding: 4px 15px;
    border-radius: 6px;
    cursor: not-allowed;
    -webkit-user-select: none;
            user-select: none;
}

.ModalUserInfo_delete_account__QA4ak:hover {
    background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/common/ModalUserInfo/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAO;IACP,iBAAiB;AACrB;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;;;;IASI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".main {\n    width: 100%;\n    height: 560px;\n    padding: 30px 0;\n}\n\n.header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    font-size: 38px;\n    font-weight: bold;\n    color: #262626;\n}\n\n.section {\n    display: flex;\n    width: 100%;\n    height: 230px;\n    padding-top: 15px;\n    border-bottom: 1px solid #CBD1D8;\n}\n\n.section_left {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: calc(100% - 435px);\n    height: 100%;\n    padding-right: 24px;\n}\n\n.avatar_box {\n    position: relative;\n    width: 135px;\n    height: 135px;\n}\n\n.change_avatar {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    bottom: 0;\n    right: 0;\n    cursor: pointer;\n}\n\n.avatar {\n    width: 135px;\n    height: 135px;\n    border-radius: 50%;\n}\n\n.username,\n.email {\n    font-size: 16px;\n    color: #000;\n}\n\n.section_right {\n    width: 435px;\n    height: 100%;\n}\n\n.form_item,\n.form_item_name {\n    width: 100%;\n    height: 70px;\n    margin-bottom: 10px;\n}\n\n.form_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.form_item_name {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.firstname_box,\n.lastname_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 208px;\n    height: 70px;\n}\n\n.item_title {\n    font-size: 14px;\n    font-weight: bold;\n    color: #000;\n}\n\n.func_butn {\n    width: 80px !important;\n}\n\n.radio_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 170px;\n    height: 100%;\n    padding: 2px;\n    border-radius: 6px;\n    background-color: #81969d;\n}\n\n.radio_item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 80px;\n    height: 100%;\n    font-size: 14px;\n    color: #cbd1d8;\n    /* cursor: pointer; */\n    cursor: not-allowed;\n}\n\n.radio_item_active {\n    border-radius: 4px;\n    font-weight: bold;\n    color: #17a8b5;\n    background-color: #fff;\n}\n\n.item_size {\n    padding: 0 50px;\n    flex: 1;\n    text-align: right;\n}\n\n.firstname_input,\n.lastname_input,\n.nickname_input {\n    width: 100%;\n    height: 43px;\n}\n\n.firstname_input:hover,\n.firstname_input:focus-within,\n.firstname_input:focus,\n.lastname_input:hover,\n.lastname_input:focus-within,\n.lastname_input:focus,\n.nickname_input:hover,\n.nickname_input:focus-within,\n.nickname_input:focus {\n    border-color: #17a8b5;\n}\n\n.language_select {\n    width: 100%;\n    height: 43px;\n    border-radius: 6px;\n\n}\n\n.section2 {\n    display: flex;\n    width: 100%;\n    height: 130px;\n    margin: 30px 0;\n}\n\n.section2_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.func_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 32px;\n}\n\n.footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    height: 50px;\n}\n\n.delete_account {\n    padding: 4px 15px;\n    border-radius: 6px;\n    cursor: not-allowed;\n    user-select: none;\n}\n\n.delete_account:hover {\n    background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ModalUserInfo_main__QQ6Kg`,
	"header": `ModalUserInfo_header__86-qa`,
	"section": `ModalUserInfo_section__016Tp`,
	"section_left": `ModalUserInfo_section_left__Bo8aM`,
	"avatar_box": `ModalUserInfo_avatar_box__Iw3zL`,
	"change_avatar": `ModalUserInfo_change_avatar__xXWyD`,
	"avatar": `ModalUserInfo_avatar__gr2jU`,
	"username": `ModalUserInfo_username__LmqdL`,
	"email": `ModalUserInfo_email__-mIqB`,
	"section_right": `ModalUserInfo_section_right__3UphB`,
	"form_item": `ModalUserInfo_form_item__wcWqQ`,
	"form_item_name": `ModalUserInfo_form_item_name__POkjS`,
	"firstname_box": `ModalUserInfo_firstname_box__WBAwb`,
	"lastname_box": `ModalUserInfo_lastname_box__E203J`,
	"item_title": `ModalUserInfo_item_title__ZGryv`,
	"func_butn": `ModalUserInfo_func_butn__cDxRa`,
	"radio_box": `ModalUserInfo_radio_box__sBuGd`,
	"radio_item": `ModalUserInfo_radio_item__fska-`,
	"radio_item_active": `ModalUserInfo_radio_item_active__VKHfm`,
	"item_size": `ModalUserInfo_item_size__xpQEx`,
	"firstname_input": `ModalUserInfo_firstname_input__aUxLN`,
	"lastname_input": `ModalUserInfo_lastname_input__zOUF6`,
	"nickname_input": `ModalUserInfo_nickname_input__85J4M`,
	"language_select": `ModalUserInfo_language_select__TKSQF`,
	"section2": `ModalUserInfo_section2__SY-nR`,
	"section2_right": `ModalUserInfo_section2_right__cpa0e`,
	"func_item": `ModalUserInfo_func_item__Ihn5D`,
	"footer": `ModalUserInfo_footer__wGRkT`,
	"delete_account": `ModalUserInfo_delete_account__QA4ak`
};
export default ___CSS_LOADER_EXPORT___;
